import { StatusComplianceIcons } from 'pages/settings/pages/compliance/constants/statusIcon'

export const statusMap = {
  under_review: StatusComplianceIcons.carrierReview,
  approved: StatusComplianceIcons.approved,
  failed: StatusComplianceIcons.reject,
  in_review: StatusComplianceIcons.pendingReview,
  pending: StatusComplianceIcons.pendingReview,
}
